import { cn } from "@productlane/lib/src/browser"

import { useWidgetReady } from "@/components/ai-widget-launcher"
import { toggleSupportWidget } from "@/stores/support-widget-store"
import { SIDEBAR_TRACK_PADDING, sidebarItemStyles } from "./sidebar-geometry"

// The launcher's 32px button floats over the top of this slot (orchestrator
// frame 44px, 6px pad, 10px up), so the row sits at the top, not centered.
export function SidebarContactRowView({
	showLabel,
	onClick,
}: {
	showLabel: boolean
	onClick: () => void
}) {
	return (
		<div
			className={cn(
				"flex h-11 w-full shrink-0 items-start max-sm:hidden",
				SIDEBAR_TRACK_PADDING,
			)}
		>
			{showLabel && (
				<button
					type="button"
					data-testid="sidebar-contact-row"
					onClick={onClick}
					className={cn(
						sidebarItemStyles(false),
						"w-full bg-transparent hover:bg-gray-150 hover:dark:bg-gray-800",
					)}
				>
					<span aria-hidden className="mr-3 h-4 w-4 flex-none" />
					<span className="min-w-0 flex-1 select-none truncate text-left text-sm font-medium tracking-tight text-primary">
						Contact us
					</span>
				</button>
			)}
		</div>
	)
}

export function SidebarContactRow({ collapsed }: { collapsed: boolean }) {
	const widgetReady = useWidgetReady()

	return (
		<SidebarContactRowView
			showLabel={!collapsed && widgetReady}
			onClick={toggleSupportWidget}
		/>
	)
}
